import PropTypes from "prop-types";
import client1 from "@/assets/VisibilityAssets/avatar.jpeg";
import client2 from "@/assets/VisibilityAssets/avatar2.jpg";
import client3 from "@/assets/VisibilityAssets/avatar.jpeg";

const ReviewCard = ({ clientImage, clientName, review }) => {
  return (
    <div className="bg-review-card border border-review-card-border rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center gap-4 mb-4">
        <img
          src={clientImage}
          alt={`${clientName}'s profile`}
          className="w-12 h-12 rounded-full object-cover border-review-card-border"
        />
        <div>
          <h3 className="font-semibold text-client-name text-[1.1em]">
            {clientName}
          </h3>
          {/* <StarRating rating={rating} size={14} /> */}
        </div>
      </div>
      <p className="text-review-text text-sm leading-relaxed line-clamp-4">
        &quot;{review}&quot;
      </p>
    </div>
  );
};

ReviewCard.propTypes = {
  clientImage: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  review: PropTypes.string.isRequired,
};

const Review = () => {
  return (
    <section className="py-14">
      <div className="bg-blue-900 py-6 px-6 mb-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Transform Your Digital Presence?
          </h2>
          <p className="text-xl text-blue-100 mb-6">
            We’re opening just a few spots for businesses ready to take
            marketing seriously. Get started today and launch your next phase
            with confidence..
          </p>
          <a href="#contact-form">
            <button className="bg-white text-blue-900 px-8 py-3 mt-5 text-[1.1em] font-semibold rounded-full hover:bg-blue-50 transition-colors duration-300">
              Get Started Today
            </button>
          </a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <ReviewCard
            clientImage={client1}
            clientName="Adaobi N. — Founder"
            review="Before Belsoft handled our marketing, we were just posting and hoping for sales. Now, we get consistent inquiries every week. The team really understood our market and helped us turn content into actual customers."
          />
          <ReviewCard
            clientImage={client2}
            clientName="Tunde A. — CEO"
            review="What stood out for me was the transparency. Every campaign had clear numbers, and we could see where our money was going. Our online presence has grown massively, and the calls haven’t stopped."
          />
          <ReviewCard
            clientImage={client3}
            clientName="Mariam S. — Manager"
            review="I used to think social media ads didn’t work for small businesses until Belsoft came in. They cleaned up our brand, created simple but effective campaigns, and in a month, our membership doubled."
          />
        </div>
      </div>
    </section>
  );
};

export default Review;
